import React from "react";
import { useTranslation } from 'react-i18next';

function AboutUs() {
  const {t}= useTranslation('aboutUs');
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{}}>
       {t("AboutUs")}
      </div>
    </div>
  );
}

export default AboutUs;
